// removed by extract-text-webpack-plugin
module.exports = {"QuestionWrapper":"QuestionWrapper__3eFTo","Question":"Question__33x7Q"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/CategoryQuestions/Question/style.scss
// module id = mb5j
// module chunks = 0